import { useState, useEffect, useRef } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { Button } from "react-bootstrap";
import "../shippingForm.css";
import emailjs from 'emailjs-com';
import { useNavigate } from "react-router-dom";

export default function ShippingGift({ onSubmit, showLoginModal, login }) {
  const [captchaValid, setCaptchaValid] = useState(false);
  const [showGuestPrompt, setShowGuestPrompt] = useState(false);
  const navigate = useNavigate(); // initialize
  const [address, setAddress] = useState({
    name: "",
    street1: "",
    street2: "",
    city: "",
    state: "",
    zip: "",
    
    country: "US",
  });

  const recaptchaRef = useRef(null);
  const addressRef = useRef(address);

  const handleAddressChange = (e) => {
    const sanitizedValue = e.target.value.replace(/[<>{}]/g, "");
    setAddress({ ...address, [e.target.name]: sanitizedValue });
  };

  const handleCaptchaChange = (value) => {
    setCaptchaValid(!!value);
  };

  useEffect(() => {
    addressRef.current = address;
  }, [address]);

  useEffect(() => {
    const input = document.getElementById("street1");
    if (!window.google || !window.google.maps || !input) return;

    const ac = new window.google.maps.places.Autocomplete(input, {
      componentRestrictions: { country: "us" },
      fields: ["address_components", "geometry"],
    });

    ac.addListener("place_changed", () => {
      const place = ac.getPlace();
      if (!place.address_components) return;

      const updatedAddress = {
        ...addressRef.current,
        street1: "",
        city: "",
        state: "",
        zip: "",
        country: "US",
      };

      for (const component of place.address_components) {
        const types = component.types;
        const value = component.long_name;

        if (types.includes("street_number")) updatedAddress.street1 = value + " ";
        if (types.includes("route")) updatedAddress.street1 += value;
        if (types.includes("locality")) updatedAddress.city = value;
        if (types.includes("administrative_area_level_1")) updatedAddress.state = value;
        if (types.includes("postal_code")) updatedAddress.zip = value;
        if (types.includes("country")) updatedAddress.country = component.short_name;
      }

      setAddress(updatedAddress);
    });
  }, []);

  const validateAddress = () => {
    const { name, street1, city, state, zip } = address;
    if (!name || !street1 || !city || !state || !zip) {
      alert("Please fill in all required fields.");
      return false;
    }
    const zipRegex = /^\d{5}(-\d{4})?$/;
    if (!zipRegex.test(zip)) {
      alert("Please enter a valid ZIP code.");
      return false;
    }
    return true;
  };

  const handleSubmit = () => {
    if (!validateAddress()) return;
    if (!captchaValid) {
      alert("Please verify you're not a robot.");
      return;
    }

    const myArr = [
      ["Name", address.name],
      ["Street", address.street1],
      ["Street2", address.street2],
      ["City", address.city],
      ["State", address.state],
      ["ZIP", address.zip],
      ["Country", address.country],
      ["Email", localStorage.getItem("userEmail") || "guest@gmail.com"]
    ];

    sendEmail(myArr);
  };

  const generateItemsTableHTML = (items) => {
    return `
      <table style="border-collapse: collapse; width: 100%; font-size: 14px;">
        <thead>
          <tr style="background-color: #f2f2f2;">
            <th style="border: 1px solid #ddd; padding: 8px;">Field</th>
            <th style="border: 1px solid #ddd; padding: 8px;">Value</th>
          </tr>
        </thead>
        <tbody>
          ${items.map(item => `
            <tr>
              <td style="border: 1px solid #ddd; padding: 8px;">${item[0]}</td>
              <td style="border: 1px solid #ddd; padding: 8px;">${item[1]}</td>
            </tr>
          `).join('')}
        </tbody>
      </table>
    `;
  };

 const sendEmail = (myArr) => {
    const htmlBody = generateItemsTableHTML(myArr);

    const emailData = {
      from_name: 'Wear & Wonder Boutique',
      to_name: 'HERE IS THE WINNER OF THE MONTH:',
      html_body: htmlBody,
    };

    emailjs
      .send('service_ra0tzqd', 'template_dcrf6kr', emailData, 'K6B2QrefJnYCDCTa1')
      .then(response => {
        // console.log('✅ Email sent successfully', response);

        // ✅ Clear the form
        setAddress({
          name: "",
          street1: "",
          street2: "",
          city: "",
          state: "",
          zip: "",
          country: "US",
        });
        if (recaptchaRef.current) recaptchaRef.current.reset();
        setCaptchaValid(false);

        // ✅ Navigate to success page
        navigate("/giftClaimSuccess");
      })
      .catch(error => {
        console.error('❌ Error sending email:', error);
        alert("Oops! Something went wrong while sending your info. Please try again.");
      });
  };

  const proceedAsGuest = () => {
    setShowGuestPrompt(false);
    onSubmit(address, "guest@gmail.com");
  };

  const openLogin = async () => {
    await login?.();
    setShowGuestPrompt(false);
    const user = localStorage.getItem("userEmail");
    if (user) {
      onSubmit(address, user);
    }
  };

  return (
    <div>
      <h2>Shipping Address</h2>
      <input className="input" name="name" placeholder="Name" value={address.name} onChange={handleAddressChange} />
      <input id="street1" className="input" name="street1" placeholder="Street address" value={address.street1} onChange={handleAddressChange} />
      <input className="input" name="street2" placeholder="Street address line 2" value={address.street2} onChange={handleAddressChange} />
      <input className="input" name="city" placeholder="City" value={address.city} onChange={handleAddressChange} />
      <input className="input" name="state" placeholder="State" value={address.state} onChange={handleAddressChange} />
      <input className="input" name="zip" placeholder="ZIP" value={address.zip} onChange={handleAddressChange} />

      <ReCAPTCHA
        ref={recaptchaRef}
        sitekey={process.env.REACT_APP_CAPTCHA_SITE_KEY2}
        onChange={handleCaptchaChange}
        style={{ marginTop: 20, marginBottom: "1rem", borderRadius: 20 }}
      />

      <button className="login-button" onClick={handleSubmit}>
        Submit Address
      </button>

      {showGuestPrompt && (
        <div
          style={{
            backgroundColor: "rgba(0,0,0,0.6)",
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1000,
          }}
        >
          <div
            style={{
              background: "white",
              padding: "2rem",
              borderRadius: "12px",
              textAlign: "center",
              width: "90%",
              maxWidth: "400px",
            }}
          >
            <h3>You're not logged in</h3>
            <p>Would you like to log in or continue as a guest?</p>

            <Button
              onClick={openLogin}
              style={{
                backgroundImage: "linear-gradient(to right, #071d49, #A60065)",
                color: "#f5efe3",
                borderRadius: 10,
                fontWeight: "bold",
                height: 40,
                border: "none",
                width: "100%",
                marginBottom: 10,
                fontSize: "13px",
                padding: "6px 12px",
              }}
            >
              Sign in with Google
            </Button>

            <button
              onClick={proceedAsGuest}
              style={{
                margin: "0.5rem",
                backgroundColor: "#ccc",
                padding: "8px 12px",
              }}
            >
              Continue as Guest
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
